import { validationMessages } from '../../translations'
import { required } from './required'
import { minLength } from './minLength'

export const passwordValidations = (password, formatMessage = undefined) => {
  const requiredError = required(password, formatMessage)
  if (requiredError) return requiredError
  const minLengthError = minLength(password, 8, formatMessage)
  if (minLengthError) return minLengthError

  const regex = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{8,4096}$/
  if (!regex.test(password)) {
    return (
      (formatMessage && formatMessage(validationMessages.causePassword)) ||
      'Must include upper and lowercase letters, a special character, and at least 1 number'
    )
  }
  return null
}
